import getFolderMruConfiguration from 'owa-service/lib/operation/getFolderMruConfigurationOperation';
/**
 * Action to get folder MRU Configuration
 * @return the TargetFolderMruConfiguration
 */
export default function getFolderMruConfigurationService() {
    return getFolderMruConfiguration().then(function (response) {
        return response;
    });
}
//# sourceMappingURL=getFolderMruConfigurationService.js.map